import { Observable, Subject } from 'rxjs';

export interface DialogRefCloseConfig {
  isOverlayClick?: boolean;
  closeOnSubmit?: boolean;
}

export class DialogRef {
  constructor() {}

  private readonly afterClosedSubject = new Subject<any>();
  afterClosed: Observable<any> = this.afterClosedSubject.asObservable();

  close(result?: DialogRefCloseConfig): void {
    this.afterClosedSubject.next(result);
  }
}
